import React, {useCallback, useMemo} from "react";
import {Col, Row} from "reactstrap";
import Chips, {ChipsContentType, ChipsIconPosition, ChipsTypes} from "../../../../../../base/chips/chips";
import ProductInformationPopover from "../../../../../../app-specific/draggable-popover/product-information-popover";
import PartAutocomplete from "../../../../../../text-fields/autocomplete/part-autocomplete";

const TargetProductsTab = ({products, setProducts, submitting}) => {
    const existingProductIds = useMemo(() => products?.map(e => e.id) ?? [], [products])

    /**
     * Adds the given product to the report.
     * @param product
     * @return {Promise<void>}
     */
    const addTargetProduct = useCallback((product) => {
        setProducts((prevState) => [...prevState, {id: product.id, partNo: product.partNo}]);
    }, [setProducts,])

    /**
     * Removes the given product from the report.
     * @param productToDelete
     * @return {Promise<void>}
     */
    const removeTargetProduct = useCallback((productToDelete) => {
        setProducts((prevState) => prevState.filter(e => e.id !== productToDelete.id));
    }, [setProducts]);


    return (
        <Row xs={12} noGutters className={" w-100"} style={{paddingInline: '2rem'}}>
            <Col xs={12}>
                <PartAutocomplete
                    clearOnBlur
                    fullWidth
                    label={"Product"}
                    value={null}
                    onChange={(_, value) => value && addTargetProduct(value)}
                    filterOptions={(options) => options.filter(e => !existingProductIds.includes(e.id))}
                />
            </Col>
            <div className={"d-flex flex-wrap w-100 mb-5 mt-3"}>
                {
                    products?.map(product => (
                        <div className={"mr-2 mb-2"} key={product.id}>
                            <Chips
                                key={product.id}
                                iconPosition={ChipsIconPosition.start}
                                contentType={ChipsContentType.element}
                                content={
                                    <ProductInformationPopover partNo={product?.partNo ?? product?.partNumber}>
                                        {product?.partNo ?? product?.partNumber ?? ''}
                                    </ProductInformationPopover>
                                }
                                onIconClick={() => removeTargetProduct(product)}
                                disabled={submitting}
                                type={submitting ? ChipsTypes.loading : ChipsTypes.remove}
                            />
                        </div>
                    ))
                }
            </div>
        </Row>

    )
};

export default TargetProductsTab;
